import React from "react"

// Botão de ação icon-only padrão do módulo de O.S.
// Markup idêntico ao usado nas tabelas (ListaOS / DetalhesOS / itens de CriarOS):
//   <button class="btn btn-light btn-sm font-size-16"><i class="bx ..."></i></button>
// `iconClassName` recebe a classe completa do <i> (ex.: "bx bx-trash align-middle text-danger")
// para reproduzir cada variação (cor de perigo, text-muted condicional, etc.).
const BotaoAcao = ({ iconClassName, onClick, title, disabled, style }) => (
  <button
    type="button"
    className="btn btn-light btn-sm font-size-16"
    onClick={onClick}
    title={title}
    disabled={disabled}
    style={style}
  >
    <i className={iconClassName}></i>
  </button>
)

export default BotaoAcao
